export default "__VITE_ASSET__CI9oqJUp__"